import { store } from "./lib/store";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import viVN from "antd/locale/vi_VN";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Routes>
        <Route
          path="*"
          element={
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#ff4d4f",
                  borderRadius: 12,
                },
              }}
              locale={viVN}
            >
              {/* toàn bộ app của bạn */}
              <App />
            </ConfigProvider>
          }
        />
      </Routes>
    </Provider>
  </BrowserRouter>
);
